import { useState } from 'react'
import { useCallback } from 'react'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'

import { Button } from '../../components'
import { AccountItem } from '../../components/account-item'
import { BankAccountItemSkeleton } from '../../components/bank-account-item'
import { VezgoConnectionModal } from '../../components/vezgo-connection-modal'
import { Paths } from '../../config/routes'
import { useAccounts } from '../../hooks/use-accounts'
import { useFeatureFlags } from '../../hooks/use-feature-flags'
import { MasaAccount, MasaConnectionProvider } from '../../models'
import { AddVezgoSkeleton } from './add-vezgo-account.skeleton'

export function AddVezgoAccount(): JSX.Element {
    const [finished, setFinished] = useState(false)
    const { hasFeature, loading: featureLoading } =
        useFeatureFlags('vezgo_connectors')
    const { accounts, setLongPulling, loading, isLongPullingAccounts } =
        useAccounts({
            type: MasaConnectionProvider.VEZGO,
        })

    const handleGetAccounts = () => {
        setLongPulling(accounts.length)
    }

    const history = useHistory()

    const handlePath = useCallback(
        (path: string) => history.push(path),
        [history],
    )

    if (featureLoading) {
        return (
            <div className='w-4/5'>
                <AddVezgoSkeleton />
            </div>
        )
    }

    if (!hasFeature) {
        return <></>
    }
    return (
        <div className='w-1/3'>
            <h1>Use Vezgo</h1>
            <p className={'mb-8 leading-loose text-black'}>
                We use Vezgo to securely link your account balances and
                transactions to build your financial profile
            </p>
            {loading && (
                <div className='flex flex-row justify-center w-full mb-8'>
                    <BankAccountItemSkeleton />
                </div>
            )}

            <div className={'flex flex-col gap-2'}>
                <VezgoConnectionModal
                    finished={finished}
                    setFinished={setFinished}
                    hide={accounts.length}
                    link={false}
                    isLongPullingAccounts={isLongPullingAccounts}
                    onFinish={() => handleGetAccounts()}
                />

                {!!accounts.length && (
                    <>
                        {accounts.map((account: MasaAccount, index: number) => (
                            <AccountItem
                                isCrypto
                                iconName={account?.amount?.currency}
                                className='rounded-md'
                                name={account.name ?? ''}
                                lastUpdatedOne={
                                    new Date((account as any).lastUpdated)
                                }
                                balanceInfo={{
                                    current: account?.amount?.value ?? 0,
                                    isoCurrencyCode:
                                        account?.amount?.currency ?? '',
                                }}
                                key={`account-${index}`}
                            />
                        ))}
                        <div className='my-2'>
                            <VezgoConnectionModal
                                finished={finished}
                                setFinished={setFinished}
                                hide={false}
                                link={true}
                                isLongPullingAccounts={isLongPullingAccounts}
                                onFinish={() => handleGetAccounts()}
                            />
                        </div>
                    </>
                )}
                {(!!accounts.length || isLongPullingAccounts) && (
                    <Link to={Paths.DASHBOARD}>
                        <Button className='px-24 py-4 w-max'>Continue</Button>
                    </Link>
                )}
                {!accounts.length && (
                    <button
                        className={
                            'h-8 text-linkYellow text-left mt-10 font-bold'
                        }
                        onClick={() => handlePath(Paths.DASHBOARD)}>
                        {' '}
                        Skip for now{' '}
                    </button>
                )}
            </div>
            <div className={'flex flex-col'}></div>
        </div>
    )
}
